const data = {
  properties:null,
  infoheader:{show:false},
  redeemTimeframe:{standard:5, homedelivery:2, onlineevent:5}
}

const set = (properties) => {
  data.properties = properties
  let infoheader = (properties || []).find(p => p.key === "INFOHEADER")
  if(infoheader) {
    data.infoheader = infoheader.value
  }
  let redeemTimeframe = (properties || []).find(p => p.key === "REDEEM_TIMEFRAME")
  if(redeemTimeframe) {
    data.redeemTimeframe = redeemTimeframe.value
  }
}

const get = () => {
  return data.properties
}

const getInfoheader = () => {
  return data.infoheader
}
const getRedeemTimeframe = () => {
  return data.redeemTimeframe
}

export default {set, get, getInfoheader, getRedeemTimeframe}